module.exports = __webpack_public_path__ + "static/media/shippigo-by-emiza.4f446bbe.svg";